import React from 'react';
import TradingViewChart from '../Common/Market/TradingViewChart';

const LiveChartBox = ({ symbol }) => {
  return (
    <div className="bg-black shadow rounded-lg p-4">
      <TradingViewChart key={symbol} symbol={symbol} />
    </div>
  );
};

export default LiveChartBox;
